'use strict';

var CreateLan = require('actionGroups/createLan/CreateLan');
var CreateLanView = require('actionGroups/createLan/CreateLanView');

module.exports = {
  Model: CreateLan,
  GroupView: CreateLanView,
};
